export function useAuthAdapter() {
  const authStore = useAuthStore();
  const userDataStore = useUserDataStore();
  const { fetchUserProfile, forceRequestKycReason } = useUserData();
  const { openForgotPassword } = useAuth();

  return {
    getIsAuthenticated: () => authStore.isAuthenticated,
    getRecoveryPasswordFlow: () => authStore.recoveryPasswordFlow,
    getForceRequestKycReason: () => forceRequestKycReason.value,
    getUserLatestKyc: () => userDataStore.user?.latestKyc,

    setAuth: authStore.setAuth,
    resetRecoveryPasswordFlow: authStore.resetRecoveryPasswordFlow,
    setRecoveryPasswordData: authStore.setRecoveryPasswordData,
    setRecoveryPasswordFlow: authStore.setRecoveryPasswordFlow,
    fetchUserProfile,
    openForgotPassword,
    logout: authStore.logout,
  };
}
